<template>
    <div>
        <div class="delivery-plan text-center" v-if="displayPlanDropdown && !isCanvasser">
            <p> {{ $t('DELIVERY_ADDRESS_CHOOSE_PLAN') }} </p>
            <multiselect
                openDirection="below"
                :allow-empty="false"
                :options="plans"
                v-model="selectedPlan"
                :inputStyle="'border-color: grey;'"
                :track-by="'plan_interval'"
                :label="'plan_name'"
                :show-labels="false"
                :placeholder="$t('DELIVERY_ADDRESS_SELECT_A_PLAN')" />
            <p class="cancel-plan-text"> {{$t('DELIVERY_ADDRESS_CANCEl_PLAN')}} </p>
        </div>
        <!-- Postcode -->
        <div class="text-center px-2 py-4 text-xl max-w-sm mx-auto">
                <p v-html="$t('DELIVERY_FORM_LOVELY_STUFF')"/>
            </div>
        <div v-if="!isUSA">
            <input-field
                class="mb-3"
                autocomplete="shipping house-number"
                v-model="address.houseNumber"
                :is-valid="!errorHandler.has('delivery_address_house_number')"
                :message="$t(errorHandler.get('delivery_address_house_number'))"
                :mandatory="!isUSA"
                :label="$t('DELIVERY_ADDRESS_FORM_HOUSE_NUMBER')"/>
        </div>

        <!-- Street -->
        <div>
            <input-field
                class="mb-3"
                autocomplete="shipping address-line1"
                v-model="address.addressLine1"
                :is-valid="!errorHandler.has('delivery_address_line_1')"
                :message="$t(errorHandler.get('delivery_address_line_1'))"
                :mandatory="true"
                :label="$t('DELIVERY_ADDRESS_FIRST_LINE')"/>
        </div>

        <!-- Additional Address Information -->
        <div>
            <input-field
                v-if="!isUSA"
                class="mb-3"
                autocomplete="shipping address-line2"
                v-model="address.addressLine2"
                placeholder="(optional)"
                :label="$t('DELIVERY_ADDRESS_SECOND_LINE')"/>
        </div>

        <!-- House Number -->
        <div v-if="isUSA">
            <input-field
                class="mb-3"
                autocomplete="shipping house-number"
                v-model="address.houseNumber"
                placeholder="(optional)"
                :is-valid="!errorHandler.has('delivery_address_house_number')"
                :message="$t(errorHandler.get('delivery_address_house_number'))"
                :mandatory="!isUSA"
                :label="$t('DELIVERY_ADDRESS_FORM_HOUSE_NUMBER')"/>
        </div>

        <!-- Postcode -->
        <div>
            <input-field
                class="mb-3"
                v-if="!isUSA"
                autocomplete="shipping postcode"
                v-model="address.postcode"
                :is-valid="!errorHandler.has('delivery_address_postcode')"
                :message="$t(errorHandler.get('delivery_address_postcode'))"
                :mandatory="true"
                :label="$t('POSTCODE_FORM_POSTCODE')"/>
        </div>

        <!-- City -->
        <div>
            <input-field
                class="mb-3"
                autocomplete="shipping address-level2"
                v-model="address.city"
                :is-valid="!errorHandler.has('delivery_address_city')"
                :message="$t(errorHandler.get('delivery_address_city'))"
                :mandatory="true"
                :label="$t('DELIVERY_ADDRESS_TOWN_OR_CITY')"/>
        </div>

        <div class="state" v-if="isUSA">
            <p class="required"> {{$t("DELIVERY_ADDRESS_STATE")}} </p>
            <Dropdown
                v-model="address.state"
                :placeholder="$t('DELIVERY_ADDRESS_STATE')"
                :items="states"
                :error="$t(errorHandler.get('delivery_address_state'))"/>
                <p class="input__message invalid-state"
                    v-if="$t(errorHandler.get('delivery_address_state'))"
                    v-text="$t(errorHandler.get('delivery_address_state'))"/>
        </div>

        <!-- Postcode -->
        <div>
            <input-field
                class="mb-3"
                v-if="isUSA"
                autocomplete="shipping postcode"
                v-model="address.postcode"
                :is-valid="!errorHandler.has('delivery_address_postcode')"
                :message="$t(errorHandler.get('delivery_address_postcode'))"
                :mandatory="true"
                :label="$t('POSTCODE_FORM_POSTCODE')"/>
        </div>

        <!-- Additional Address Information -->
        <!-- <div> -->
            <!-- <input-field -->
                <!-- class="mb-3"
                autocomplete="shipping address-line2"
                v-model="address.addressLine2"
                :label="$t('DELIVERY_ADDRESS_SECOND_LINE')"/> -->
        <!-- </div> -->

        <delivery-waiting-list-modal
            :show-modal="showUndeliverablePostcodeModal"
            @closed="toggleUndeliverablePostcodeModal"
            :joinWaitList="showWaitListText"
            @hideJoinList="toggleShowWaitListText"
            :postcode="address.postcode"/>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import { Dropdown } from '@freddiesflowers/frontend-component-library';
import Countries from '@/resources/countries.json';
import InputField from '@/components/forms/fields/InputField';
import PostcodeService from '@/services/logistics/PostcodeService';
import DeliveryWaitingListModal from '@/components/modals/DeliveryWaitingListModal';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import { isPostcodeFormatValid } from '@/helpers/PostcodeHelpers';

export default {
    name: 'DeliveryAddressForm',
    data: () => {
        return {
            postcodeComponent: null,
            address: {
                houseNumber: null,
                addressLine1: null,
                addressLine2: null,
                city: null,
                postcode: null,
                state: null,
            },
            showUndeliverablePostcodeModal: false,
            showWaitListText: false,
        };
    },
    props: {
        value: {
            required: true,
            type: Object,
        },
        errorHandler: {
            required: false,
            default: () => new ErrorResponseHandler(),
            validator: function(value) {
                return value instanceof ErrorResponseHandler;
            },
        },
        displayPlanDropdown: {
            required: false,
            type: Boolean,
            default: true,
        },

    },
    computed: {
        ...mapGetters({
            getPauseIsCancel: 'subscription/getPauseIsCancel',
            isUSA: 'localisation/isUSA',
            isCanvasser: 'auth/isCanvasser',
        }),
        plans() {
            return this.$store.getters['register/getAllPlans'];
        },
        selectedPlan: {
            get() {
                return this.$store.getters['register/getSelectedPlan'] || this.plans[0];
            },
            set(value) {
                this.$store.commit('register/setSelectedPlan', value);
            },
        },
        states() {
            const USA = Countries.find((item) => item.iso === 'USA');
            return USA.states;
        },
        isPostcodeValid() {
            return this.address.postcode === null || isPostcodeFormatValid(this.address.postcode);
        },
    },
    methods: {
        updateSelectedAddress(address) {
            this.address.houseNumber = address.houseNumber;
            this.address.addressLine1 = address.addressline1;
            this.address.addressLine2 = address.addressline2;
            this.address.city = address.county;
            this.address.state = address.state;
        },
        toggleUndeliverablePostcodeModal(value) {
            this.showUndeliverablePostcodeModal = value || !this.showUndeliverablePostcodeModal;
        },
        clearAddress(value) {
            if (value) {
                this.address.houseNumber = null;
                this.address.addressLine1 = null;
                this.address.addressLine2 = null;
                this.address.city = null;
                this.address.state = null;
            }
        },
        toggleShowWaitListText() {
            this.showWaitListText = !this.showWaitListText;
        },
    },
    watch: {
        address: {
            deep: true,
            handler(address) {
                this.$emit('input', address);
            },
        },
        'address.postcode': function(newPostcode, oldPostcode) {
            newPostcode = (newPostcode || '').toLowerCase();
            oldPostcode = (oldPostcode || '').toLowerCase();
            if ((oldPostcode !== newPostcode) && this.isPostcodeValid && this.getPauseIsCancel) {
                PostcodeService.fetchPostcodeDeliverableStatus(newPostcode)
                    .catch(() => {
                        this.toggleUndeliverablePostcodeModal(true);
                        this.toggleShowWaitListText();
                    });
            }
        },
        value: {
            immediate: true,
            handler(value) {
                this.address.houseNumber = value.houseNumber;
                this.address.addressLine1 = value.addressLine1;
                this.address.addressLine2 = value.addressLine2;
                this.address.postcode = value.postcode;
                this.address.city = value.city;
                this.address.state = value.state;
            },
        },
    },
    components: {
        Multiselect,
        InputField,
        DeliveryWaitingListModal,
        Dropdown,
    },
};
</script>

<style lang="scss" scoped>
    .state {
        margin-bottom: 10px;
        padding: 0px 15px;
        text-align: left;
    }
    .required:after {
        content:" *";
        color: red;
    }

    .invalid-state {
        color: rgba(177, 71, 60, 1);
    }
</style>
